import axios from 'axios';

const getCSRFTokenFromCookie = () =>
  document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith('CSRF-TOKEN='))
    ?.split('=')[1];

const getCSRFTokenFromMeta = () => document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;

// Prefer the cookie (refreshed on every response, so it tracks the current session) over the
// meta tag (frozen at full-page load, which goes stale if the session is renewed afterwards).
const getCSRFToken = () => decodeURIComponent(getCSRFTokenFromCookie() || getCSRFTokenFromMeta() || '');

axios.defaults.headers.common.Accept = 'application/json'; // Ensure Rails returns JSON instead of HTML
axios.interceptors.request.use((config) =>
  Object.assign(config, { headers: { ...config.headers, 'X-CSRF-Token': getCSRFToken() } }),
); // Attach Rails CSRF token to every request
